<!--
 * @Descripttion: 
 * @Author: lijingjing56
 * @Date: 2024-08-09 13:59:22
 * @LastEditors: lijingjing56
 * @LastEditTime: 2025-01-09 14:36:21
-->
<template>
    <div class="container">
        <banner
            title="携手合作伙伴，共建数智生态"
            describe="京东DAAS坚持开放包容、共生共创的生态理念，携手生态伙伴以京东先进的产品技术与丰富的平台资源，为品牌客户提供优质数智服务"
            imgUrl="//img10.360buyimg.com/img/jfs/t1/165991/7/50677/44525/673db3bbF4e36c805/93ea219fb32ad879.jpg"
            :router="router"
            :link="link"
        />
        <joinList title="多种生态伙伴类型" :data-list="joinData"></joinList>
        <product-solution/>
        <partner title="合作伙伴优秀案例" :mess="'浏览全部案例'"></partner>
    </div>
</template>
<script>
import banner from '../../components/banner.vue';
import joinList from "../../components/joinList.vue";
import partner from './partner';
import productSolution from './productSolution';
export default {
    name: 'home',
    components: {
        banner,
        joinList,
        partner,
        productSolution,
    },
    data() {
      return {
        joinData:[
        {
          name: "渠道伙伴",
          source:'//img10.360buyimg.com/img/jfs/t1/175304/4/52735/8079/673d8f4fF81726d7b/5ffa2e4b08d926b7.png',
          describe:
            "具备京东数智产品推广、咨询和销售能力，与京东共同拓展市场，推动更多品牌使用京东数智产品及服务。"
          },
        {
          name: "服务伙伴",
          source:'//img10.360buyimg.com/img/jfs/t1/175304/4/52735/8079/673d8f4fF81726d7b/5ffa2e4b08d926b7.png',
          describe:
            "依托京东数智产品，为品牌提供数智产品场景应用及解决方案等专业数智服务，助力品牌在全域多维度业务增长。"
          },
          {
          name: "ISV伙伴",
          source:'//img10.360buyimg.com/img/jfs/t1/175304/4/52735/8079/673d8f4fF81726d7b/5ffa2e4b08d926b7.png',
          describe:
            "具备自主产品、技术研发能力，与京东共建更智能便捷的数智工具，为品牌提供更高效的数智产品或解决方案，拓展数智收入。"
          }
        ],
        link:'',
        router:'加入我们'
    };
  },
  mounted(){
    this.link = `${window.location.origin}/cloud/about/us`
  }
}
</script>